export enum EServiceChangeRequestToggleHeaders {
  REVIEW = 'REVIEW',
  WIZARD = 'WIZARD',
  CODE_EDITOR = 'CODE_EDITOR',
  PREVIEW = 'PREVIEW',
  FORM_MODEL = 'FORM_MODEL',
}
